<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
        <app-side-nav [item]="meetingNav"></app-side-nav>
    </div> -->
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="div-style">
      <div class="breadcrumbs-section">
        <span class="prev-page pr-1 "><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="prev-page pr-1 "><a routerLink="/employees/employees-list">Employees</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="prev-page pl-1 breadcrumbs-section-font"><a
            routerLink="/employees/employees-list/add-employees">Add Employees</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Status</span>
      </div>
      <div class="">
        <div class="padding-left-employees">
          <div class="row">
            <img class="image-width" src="assets/images/success-tick.png" loading="lazy">
            <div class="d-flex flex-column pl-4 pt-1">
              <span class="successfully-added">
                Successfully added
              </span>
              <span class="employee-profiles-text">
                Employee profiles successfully created.
              </span>
            </div>
          </div>

        </div>
      </div>
      <div class="padding-left-employees">
        <div class="details-background mt-5 pb-4">
          <label class="employee-preview employee-preview-box mt-4">Employee Preview</label>
          <div class="row details-container">
            <div class="col-10">
              <div class="row mt-3 d-flex">
                <div class="col-6  ">
                  <div class="col-12 flex-column">
                    <span class="name">
                      Full Name
                    </span>
                  </div>
                  <div class="col-12 flex-column">
                    <span class="details">
                      {{userInfo?.data?.userName}}
                    </span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="col-12 flex-column">
                    <span class="name">
                      Email ID
                    </span>
                  </div>
                  <div class="col-12 flex-column">
                    <span class="details">
                      {{userInfo?.data?.emailId|lowercase}}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row  mt-3">
                <div class="col-6">
                  <div class="col-12">
                    <span class="name">
                      Mobile Number
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                     <span *ngIf="!userInfo?.data?.phoneNumber.includes('+')">+91</span> {{userInfo?.data?.phoneNumber}}
                    </span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="col-12">
                    <span class="name">
                      Department
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{deptInfo?.data?.department}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="circle">
                <div class="circle-name">{{acronym}}</div>
              </div>
            </div>

          </div>

          <div class="employee-preview-box employee-preview-box-right row">
            <div class="line mb-2"></div>
          </div>
          <div class="employee-preview-box pr-4 row">
            <div class="pt-3 pb-3 col-8">
              <button class="view-details" (click)="viewEmployeeDetails()">View Details</button>
            </div>
            <div class="d-flex pt-3 pb-3 justify-content-end col-4">
              <button class="view-details " (click)="resendEmail()">Resend email &nbsp; |</button>
              <button class="view-details " (click)="openRevoke()">Revoke invitation</button>
              <ng-template #revokeInvitationOne let-modal class="text-center">
                <div class="modal-height">
                  <div class="modal-body">
                    <div class="">
                      <div class="text pt-3 pb-3">Are you sure, you want to revoke invitation?</div>
                      <div class="popup-line"></div>
                    </div>
                  </div>
                  <div class="submit col-12 d-flex justify-content-end col-12-padding ">
                    <div class="pr-3">
                      <button type="button " class="cancel-button cancel pt-3"
                        (click)="modal.close('Save click');onCancel('priviledge')">
                        <span class="cancel">Cancel</span></button>
                    </div>
                    <button type="button " class="add-button" (click)="revokeAccess()"><span
                        class="add">Revoke</span></button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="d-flex col-12 justify-content-end bottom-space" style="width: 92%;">
          <div class="row pt-5 ">
            <button class="cancel-button">
              <span class="cancel pr-4" (click)="bulkUploadEmployees()">Bulk Upload employees</span>
            </button>
            <button class="add-button">
              <span class="add" (click)="addEmployee()">Add Employee</span>
            </button>
          </div>

        </div>
      </div>

    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
